import WidgetsIcon from "@mui/icons-material/Widgets";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import BarChartIcon from "@mui/icons-material/BarChart";
import LinkIcon from "@mui/icons-material/Link";

export const INTEGRATION_TYPES = {
  DEFAULT: "default",
  PASSAGENS_TOTALBUS: "passagens_totalbus",
  PASSAGENS_PRAXXIO: "passagens_praxxio",
  PASSAGENS_RODOSOFT: "passagens_rodosoft",
  PASSAGENS_DISTRIBUSION: "passagens_distribusion",
  PASSAGENS_RODOVIARIAONLINE: "passagens_rodoviariaonline",
  PASSAGENS_GOPASS: "passagens_gopass",
  PASSAGENS_BUSON: "passagens_buson",
  POWER_BI: "power_bi",
  WEBHOOK: "webhook",
};

export const INTEGRATION_CARDS = [
  {
    key: INTEGRATION_TYPES.DEFAULT,
    label: "Default",
    description: "Integração genérica (sem template fixo).",
    icon: (props) => <WidgetsIcon {...props} />,
    providerHint: null,
  },
  {
    key: INTEGRATION_TYPES.PASSAGENS_TOTALBUS,
    label: "Passagens - RJ (Totalbus)",
    description: "Integração de passagens via RJ (ERP Totalbus).",
    icon: (props) => <DirectionsBusIcon {...props} />,
    providerHint: "totalbus",
    passagensPartner: "totalbus",
  },
  {
    key: INTEGRATION_TYPES.PASSAGENS_PRAXXIO,
    label: "Passagens - Praxio (Luna)",
    description: "Integração de passagens via Praxio (ERP Luna).",
    icon: (props) => <DirectionsBusIcon {...props} />,
    providerHint: "praxxio",
    passagensPartner: "praxxio",
  },
  {
    key: INTEGRATION_TYPES.PASSAGENS_RODOSOFT,
    label: "Passagens - Rodosoft",
    description: "Integração de passagens com Rodosoft.",
    icon: (props) => <DirectionsBusIcon {...props} />,
    providerHint: "rodosoft",
    passagensPartner: "rodosoft",
  },
  {
    key: INTEGRATION_TYPES.PASSAGENS_DISTRIBUSION,
    label: "Passagens - Distribusion",
    description: "Integração de passagens com Distribusion.",
    icon: (props) => <DirectionsBusIcon {...props} />,
    providerHint: "distribusion",
    passagensPartner: "distribusion",
  },
  {
    key: INTEGRATION_TYPES.PASSAGENS_RODOVIARIAONLINE,
    label: "Passagens - Rodoviária Online",
    description: "Integração de passagens com Rodoviária Online.",
    icon: (props) => <DirectionsBusIcon {...props} />,
    providerHint: "rodoviariaonline",
    passagensPartner: "rodoviariaonline",
  },
  {
    key: INTEGRATION_TYPES.PASSAGENS_GOPASS,
    label: "Passagens - Gopass",
    description: "Integração de passagens com Gopass.",
    icon: (props) => <DirectionsBusIcon {...props} />,
    providerHint: "gopass",
    passagensPartner: "gopass",
  },
  {
    key: INTEGRATION_TYPES.PASSAGENS_BUSON,
    label: "Passagens - Buson",
    description: "Integração de passagens com Buson.",
    icon: (props) => <DirectionsBusIcon {...props} />,
    providerHint: "buson",
    passagensPartner: "buson",
  },
  {
    key: INTEGRATION_TYPES.POWER_BI,
    label: "Power BI",
    description: "Conector para relatórios e compartilhamento.",
    icon: (props) => <BarChartIcon {...props} />,
    providerHint: "powerbi",
  },
  {
    key: INTEGRATION_TYPES.WEBHOOK,
    label: "Webhook",
    description: "Integração via callbacks HTTP.",
    icon: (props) => <LinkIcon {...props} />,
    providerHint: "webhook",
  },
];

export const findIntegrationCardByKey = (key) =>
  INTEGRATION_CARDS.find((c) => c.key === key) ||
  INTEGRATION_CARDS.find((c) => c.key === INTEGRATION_TYPES.DEFAULT);

const norm = (v) => String(v || "").trim().toLowerCase();

/** Virtual table row id from Integrations list, e.g. `passagens:praxxio` */
export const passagensVirtualIdToTypeKey = (id) => {
  const s = norm(id);
  if (!s.startsWith("passagens:")) return null;
  const partner = s.replace(/^passagens:/, "");
  const passagensMap = {
    totalbus: INTEGRATION_TYPES.PASSAGENS_TOTALBUS,
    praxxio: INTEGRATION_TYPES.PASSAGENS_PRAXXIO,
    rodosoft: INTEGRATION_TYPES.PASSAGENS_RODOSOFT,
    distribusion: INTEGRATION_TYPES.PASSAGENS_DISTRIBUSION,
    rodoviariaonline: INTEGRATION_TYPES.PASSAGENS_RODOVIARIAONLINE,
    gopass: INTEGRATION_TYPES.PASSAGENS_GOPASS,
    buson: INTEGRATION_TYPES.PASSAGENS_BUSON,
  };
  return passagensMap[partner] || null;
};

export const inferIntegrationTypeKey = (integration) => {
  const fromVirtual = passagensVirtualIdToTypeKey(integration?.id);
  if (fromVirtual) return fromVirtual;

  const provider = norm(integration?.provedor);
  const name = norm(integration?.nome);
  const baseUrl = norm(integration?.base_url);

  // Passagens partners (provedor)
  const passagensMap = {
    totalbus: INTEGRATION_TYPES.PASSAGENS_TOTALBUS,
    praxxio: INTEGRATION_TYPES.PASSAGENS_PRAXXIO,
    rodosoft: INTEGRATION_TYPES.PASSAGENS_RODOSOFT,
    distribusion: INTEGRATION_TYPES.PASSAGENS_DISTRIBUSION,
    rodoviariaonline: INTEGRATION_TYPES.PASSAGENS_RODOVIARIAONLINE,
    gopass: INTEGRATION_TYPES.PASSAGENS_GOPASS,
    buson: INTEGRATION_TYPES.PASSAGENS_BUSON,
  };
  if (provider && passagensMap[provider]) return passagensMap[provider];

  // Heurísticas (valores comuns vindos da API / cadastros antigos)
  if (
    provider === "power_bi" ||
    provider.includes("power") ||
    name.includes("power bi") ||
    baseUrl.includes("powerbi")
  ) {
    return INTEGRATION_TYPES.POWER_BI;
  }
  if (
    provider === "webhook" ||
    provider.includes("webhook") ||
    name.includes("webhook") ||
    baseUrl.includes("webhook")
  ) {
    return INTEGRATION_TYPES.WEBHOOK;
  }

  return INTEGRATION_TYPES.DEFAULT;
};

